import { useState } from "react";
import { useRevalidate } from "@/lib/loader";

/**
 * Shown by the app layout when the backend can't be reached (e.g. a cold
 * start), instead of treating a failed workspace fetch as "no workspaces".
 */
export function BackendUnavailable() {
  const revalidate = useRevalidate();
  const [retrying, setRetrying] = useState(false);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[color:var(--background)] p-6 text-[color:var(--foreground)]">
      <div className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-8 text-center shadow-sm dark:border-border dark:bg-surface">
        <h1 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
          Can&apos;t reach the server
        </h1>
        <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
          The backend is unavailable right now. It may be starting up — give it a
          moment and retry.
        </p>
        <button
          type="button"
          disabled={retrying}
          onClick={() => {
            setRetrying(true);
            revalidate();
            // Re-enable shortly so the user can retry again if it's still down.
            setTimeout(() => setRetrying(false), 2500);
          }}
          className="mt-5 inline-flex items-center justify-center rounded-lg bg-zinc-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-zinc-100 dark:text-zinc-900 dark:hover:bg-white"
        >
          {retrying ? "Retrying…" : "Retry"}
        </button>
      </div>
    </div>
  );
}
